<template lang="html">
      <div id="printArea">
          <div class="tabTtl">
              <span>基本情况表</span>
          </div>
          <div class="tabCage">
                <table>
                     <tr class="cpLine">
                         <td class="stype_1"></td>
                         <td class="stype_2"></td>

                         <td class="stype_3"></td>
                         <td></td>
                         <td></td>

                         <td class="stype_1"></td>
                         <td class="stype_2"></td>

                         <td></td>
                         <td></td>
                         <td class="stype_3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">单位名称</td>
                         <td colspan="8"></td>
                     </tr>
                     <tr>
                         <td colspan="2">地址</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">邮政编码</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">联系人</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">联系电话</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">主办单位</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">联系人</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">地址/邮编</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">联系电话</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">主管单位</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">联系人</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">地址/邮编</td>
                         <td colspan="3">aaa</td>
                         <td colspan="2">联系电话</td>
                         <td colspan="3">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">职工总数</td>
                         <td class="stype_3"></td>
                         <td colspan="2">从事音像电子业务人员数</td>
                         <td colspan="2"></td>
                         <td colspan="2">其他人员数</td>
                         <td class="stype_3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">企业性质</td>
                         <td colspan="3">aaa</td>
                         <td colspan="3">若企业性质为“其他”请填写</td>
                         <td colspan="2">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2">注册资本</td>
                         <td></td>
                         <td colspan="2">资产总额</td>
                         <td colspan="2"></td>
                         <td colspan="2">负债总额</td>
                         <td></td>
                     </tr>
                     <tr>
                         <td colspan="3">2017年本单位销售收入（万元）</td>
                         <td colspan="2">aaa</td>
                         <td colspan="3">2018年本单位销售收入（万元）</td>
                         <td colspan="2">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="3">2017年本单位利润总额（万元）</td>
                         <td colspan="2">aaa</td>
                         <td colspan="3">2018年本单位利润总额（万元）</td>
                         <td colspan="2">aaa</td>
                     </tr>
                     <tr>
                         <td colspan="2" rowspan="5">音像制品载体出版</td>
                         <td colspan="2">年度</td>
                         <td colspan="3">2017年</td>
                         <td colspan="3">2018年</td>
                     </tr>
                     <tr>
                         <td colspan="2">出版品种数</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">销售数量（套/张）</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">销售收入（万元）</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">利润总额（万元）</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2" rowspan="2">音像制品信息网络出版</td>
                         <td colspan="2">销售收入（万元）</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2">利润总额（万元）</td>
                         <td colspan="3"></td>
                         <td colspan="3"></td>
                     </tr>
                     <tr>
                         <td colspan="2" rowspan="2">经营范围</td>
                         <td colspan="8">

                         </td>
                     </tr>
                     <tr>
                         <td colspan="3">
                            除音像电子出版业务外本单位或本部门经营的其他主要业务
                         </td>
                         <td colspan="5"></td>
                     </tr>
                     <tr>
                         <td class="stype_1" rowspan="5">出版单位资质情况</td>
                         <td class="stype_2" rowspan="3">法人情况</td>
                         <td colspan="2">是否独立法人</td>
                         <td class="stype_2"></td>
                         <td colspan="3">独立法人隶属关系</td>
                         <td colspan="2"></td>
                     </tr>
                     <tr>
                         <td colspan="3">独立法人单位类型</td>
                         <td colspan="5"></td>
                     </tr>
                     <tr>
                         <td colspan="2">是否为非独立法人</td>
                         <td></td>
                         <td colspan="3">非独立法人隶属关系</td>
                         <td colspan="2"></td>
                     </tr>
                     <tr>
                         <td colspan="3">出版资质获批时间</td>
                         <td colspan="6"></td>
                     </tr>
                     <tr>
                         <td colspan="3">需要说明的其他情况</td>
                         <td colspan="6"></td>
                     </tr>
                </table>
          </div>
      </div>
</template>

<script>
    import { getPressList,tabRead1,tabRead2,tabRead3,tabRead7 } from '@/api/pressRole/pressRole';
    export default {
         return(){
              tabList:''
         },
         methods:{
              datPrev:function(idArrs){
                   let promiseArr = [];
                   promiseArr.push(new Promise((resolve,reject) => {
                        tabRead1({id:idArrs[0]}).then(response => {
                             resolve(response);
                        }).catch(error => {
                             reject(error);
                        })
                   }))

                   promiseArr.push(new Promise((resolve,reject) => {
                        tabRead2({id:idArrs[1]}).then(response => {
                             resolve(response);
                        }).catch(error => {
                             reject(error);
                        })
                   }))

                   promiseArr.push(new Promise((resolve,reject) => {
                        tabRead3({id:idArrs[2]}).then(response => {
                             resolve(response);
                        }).catch(error => {
                             reject(error);
                        })
                   }))

                   promiseArr.push(new Promise((resolve,reject) => {
                        tabRead7({id:idArrs[3]}).then(response => {
                             resolve(response);
                        }).catch(error => {
                             reject(error);
                        })
                   }))

                   Promise.all(promiseArr).then(result => {
                        console.log(result);
                   })
              }
         },
         created:function(){
              getPressList({type:1}).then(response => {
                   let unFormate = response.yearVerificationList;
                   let idArr = [];

                   function isInside(code){
                       return code == 201 || code == 202 || code == 203 || code == 207;
                   }

                   for(let i = 0;i < unFormate.length;i++){
                       if(isInside(unFormate[i].materialCode)){
                            idArr.push(unFormate[i].id);
                       }
                   }

                   this.datPrev(idArr);
              })
         }
    }
</script>

<style lang="scss">
   #printArea{
       .tabTtl{
           font-size: 24px;
           text-align: center;
       }

       .tabCage{
           margin-top: 30px;
           table{
               width: 1200px;
               margin: 0 auto;
               td{
                   border-collapse: collapse;
                   border: 1px solid #000000;
                   padding: 9px 12px;
                   height: 42px;
                   text-align: center;
               }

               .stype_1{
                   width: 30px;
               }

               .stype_2{
                   width: 90px;
               }

               .stype_3{
                   width: 120px;
               }

               .cpLine td{
                   // height: 0px !important;
               }
           }
       }
   }
</style>



// WEBPACK FOOTER //
// editPrint.vue?62a6d6af